(() => {
  const collectionRoot =
    document.querySelector('.collection') ||
    document.querySelector('#FacetFiltersForm') ||
    document.querySelector('[data-section-type="main-collection-product-grid"]') ||
    document.querySelector('[data-section-type="main-search"]');

  if (!collectionRoot) return;

  const whenIdle = (fn, timeout = 2000) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout });
    } else {
      setTimeout(fn, 300);
    }
  };

  const log = (msg) => {
    if (window.devLog) {
      window.devLog('PLPFeatures', msg);
    }
  };

  /**
   * Quick Add Module
   * Icon-based quick add with loading + success states
   */
  const QuickAdd = {
    selectors: {
      quickAddBtn: '[data-sa-quick-add]',
    },

    init() {
      const quickAddEnabled = window.SA_THEME?.quickAddEnabled === true;

      if (!quickAddEnabled) {
        log('Quick Add disabled via toggle');
        return;
      }

      const quickAddBtns = document.querySelectorAll(this.selectors.quickAddBtn);

      if (quickAddBtns.length === 0) {
        log('No quick add buttons found in DOM');
        return;
      }

      if (window.initOnce && !window.initOnce(collectionRoot, 'quick-add')) {
        log('Quick Add already initialized');
        return;
      }

      log(`Initializing Quick Add (${quickAddBtns.length} buttons)`);
      this.bindEvents(quickAddBtns);
    },

    bindEvents(buttons) {
      buttons.forEach((btn) => {
        btn.addEventListener('click', this.handleQuickAdd.bind(this));
      });
    },

    handleQuickAdd(event) {
      event.preventDefault();
      event.stopPropagation();
      const btn = event.currentTarget;
      const variantId = btn.dataset.variantId;

      if (variantId) {
        log(`Quick add variant: ${variantId}`);
        this.addToCart(variantId, btn);
      }
    },

    async addToCart(variantId, btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.classList.remove('is-success');

      try {
        const cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const payload = {
          id: variantId,
          quantity: 1,
        };

        if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
          payload.sections = cartUI.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        log(`Added to cart: ${data.title}`);

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'quick-add',
            productVariantId: variantId,
            cartData: data,
          });
        }

        if (cartUI && cartUI.classList.contains('is-empty')) {
          cartUI.classList.remove('is-empty');
        }

        if (cartUI && typeof cartUI.renderContents === 'function' && data.sections) {
          cartUI.renderContents(data);
        }

        // Show success state
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');

        // Reset after delay
        setTimeout(() => {
          btn.classList.remove('is-success');
          btn.disabled = false;
        }, 1500);

        document.dispatchEvent(new CustomEvent('cart:add:success', {
          detail: { item: data },
        }));

      } catch (error) {
        log(`Quick add error: ${error.message}`);
        btn.classList.remove('is-loading');
        btn.disabled = false;

        document.dispatchEvent(new CustomEvent('cart:add:error', {
          detail: { error: error.message },
        }));
      }
    },
  };

  /**
   * Color Swatches Module
   * Swaps the product card image when a swatch is clicked
   */
  const ColorSwatches = {
    selectors: {
      swatchContainer: '.p-product-card__swatches',
      swatch: '.p-product-card__swatch',
      primaryImage: '.p-product-card__img--primary',
    },

    init() {
      const containers = document.querySelectorAll(this.selectors.swatchContainer);

      if (containers.length === 0) {
        log('No color swatches found');
        return;
      }

      if (window.initOnce && !window.initOnce(collectionRoot, 'color-swatches')) {
        log('Color Swatches already initialized');
        return;
      }

      log(`Initializing Color Swatches (${containers.length} cards)`);
      this.bindEvents(containers);
    },

    bindEvents(containers) {
      containers.forEach((container) => {
        container.addEventListener('click', (event) => {
          const swatch = event.target.closest(this.selectors.swatch);
          if (!swatch) return;
          this.handleSwatchClick(swatch, container);
        });
      });
    },

    handleSwatchClick(swatch, container) {
      const imageUrl = swatch.dataset.swatchImage;
      if (!imageUrl) return;

      // Update active state
      container.querySelectorAll(this.selectors.swatch).forEach((s) => {
        s.classList.remove('is-active');
      });
      swatch.classList.add('is-active');

      // Find the card and swap the primary image
      const card = container.closest('.p-product-card');
      if (!card) return;

      const primaryImg = card.querySelector(this.selectors.primaryImage);
      if (!primaryImg) return;

      // Swap image with smooth transition
      primaryImg.style.opacity = '0';
      setTimeout(() => {
        primaryImg.src = imageUrl;
        primaryImg.style.opacity = '1';
      }, 200);

      log(`Swatch: ${swatch.dataset.swatchValue} → image swapped`);
    },
  };

  function init() {
    document.documentElement.classList.add('sa-plp-ready');
    log('PLP init starting');

    QuickAdd.init();
    ColorSwatches.init();

    log('PLP init complete');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenIdle(init));
  } else {
    whenIdle(init);
  }
})();
